import { PUBLIC_KEY_BASE64_MAX_SIZE, PUBLIC_KEY_BASE64_MIN_SIZE, } from '../constants';
import { base64Validator } from './base64';
export const publicKeyValidator = base64Validator({
    requiredError: 'internal.key.required',
    invalidFormatError: 'internal.key.base64',
    minLength: {
        min: PUBLIC_KEY_BASE64_MIN_SIZE,
        error: 'internal.key.minLength',
    },
    maxLength: {
        max: PUBLIC_KEY_BASE64_MAX_SIZE,
        error: 'internal.key.maxLength',
    },
});
